import { render, staticRenderFns } from "./cadastraTutor.vue?vue&type=template&id=d2ba438a"
import script from "./cadastraTutor.vue?vue&type=script&lang=js"
export * from "./cadastraTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports